import React from 'react';
import { CelebrationIcon, Modal, Typography, WarningIcon2 } from '@orijinworks/frontend-commons';
import {
  PLAN_STATUS,
  PLAN_STATUS_CONFIRM_COPY,
  PLAN_STATUS_LEARNER_NAME_PLACEHOLDER,
} from '../../../../constants/reentry-planning.constants';
import {
  getStatusChangeConfirmWrapperStyles,
  StatusChangeConfirmModalStyles,
} from './StatusChangeConfirmModal.styles';

const resolveConfirmBody = (body, learnerName) =>
  body.replaceAll(PLAN_STATUS_LEARNER_NAME_PLACEHOLDER, learnerName || 'the learner');

const isWarningStatus = (targetStatus) =>
  targetStatus === PLAN_STATUS.ACTIVE || targetStatus === PLAN_STATUS.ARCHIVED;

const WARNING_ICON_SX = {
  color: 'var(--navy-main, #061E44)',
  fontSize: 32,
};

const ConfirmIcon = ({ targetStatus }) => {
  if (targetStatus === PLAN_STATUS.RELEASED) {
    return <CelebrationIcon data-testid="status-change-celebration-icon" />;
  }

  return <WarningIcon2 sx={WARNING_ICON_SX} data-testid="status-change-warning-icon" />;
};

export function StatusChangeConfirmModal({
  open = false,
  targetStatus,
  learnerName,
  onConfirm,
  onCancel,
}) {
  const copy = PLAN_STATUS_CONFIRM_COPY[targetStatus];
  if (!copy) {
    return null;
  }

  const body = resolveConfirmBody(copy.body, learnerName);
  const isWarning = isWarningStatus(targetStatus);

  return (
    <Modal
      open={open}
      onClose={onCancel}
      onContinue={onConfirm}
      actionBtnText={copy.confirm}
      cancelBtnText="Cancel"
      Icon={<ConfirmIcon targetStatus={targetStatus} />}
      modalType={{ type: 'confirmation', status: 'info', size: 'medium' }}
      labelledBy={copy.heading}
      describedBy={body}
      styles={{
        mainWrapperStyles: getStatusChangeConfirmWrapperStyles(isWarning),
      }}
      mainModalStyles={StatusChangeConfirmModalStyles}
    >
      <Typography variant="h6">{copy.heading}</Typography>
      <Typography variant="body1">{body}</Typography>
    </Modal>
  );
}
